/**
 * 주문 수량 선택 옵션
 * 0.1부터 0.9까지, 그리고 10.0부터 50.0까지의 수량 옵션을 제공합니다.
 */
export const QUANTITY_OPTIONS = [
    { label: '0.1', value: '0.1' },
    { label: '0.2', value: '0.2' },
    { label: '0.3', value: '0.3' },
    { label: '0.4', value: '0.4' },
    { label: '0.5', value: '0.5' },
    { label: '0.6', value: '0.6' },
    { label: '0.7', value: '0.7' },
    { label: '0.8', value: '0.8' },
    { label: '0.9', value: '0.9' },
    { label: '10.0', value: '10.0' },
    { label: '20.0', value: '20.0' },
    { label: '30.0', value: '30.0' },
    { label: '40.0', value: '40.0' },
    { label: '50.0', value: '50.0' },
];
//# sourceMappingURL=order.js.map